 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		57: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + "." + {"0":"3ad6759b17645517b726","1":"6c095b6477fe8a1d753e","2":"ef85a778fbc3ec365a4c","3":"72abc096465a8d241ebf","4":"22cba545d4611a60bcb4","5":"c25df9483b9b4778fba0","6":"dcab8ac84bc224758286","7":"95b3bb142c4abe1c22cf","8":"d03a80ef147f173eea46","9":"f5abafd3039276b0e3a7","10":"97296737b94e3ecb57ce","11":"d6456f7bef321b5707ed","12":"5466fe293551206e115a","13":"fb0eaf6239d57da81065","14":"cdd00d0934799b7c677f","15":"e11d7e8e5d208d878c1d","16":"321d50d325c1e93d378b","17":"fa228646d42f655c053d","18":"12090452bdcd45fef5d7","19":"97ff5815ab58ffed89c7","20":"5b307bd31b14f94a8491","21":"5788e04a9c56cb7ffbce","22":"8095fafb89a623e288fd","23":"655ea087e3c31d3b22de","24":"25f27cef6a9c7603bf6f","25":"e5fb44803127dbcbe38d","26":"72ade291c21bcd121ac7","27":"bdbb5849af16d9be4870","28":"3dd6a174628eec74a924","29":"b343f5b6db748a2be0c9","30":"7e10e2dc5f8a13efc51b","31":"e453580a2bc437587ff0","32":"43814f0754a5ea846177","33":"84f112f58ff751edaa1c","34":"c263386309b00e1287a0","35":"86d68b47b10dc5686e48","36":"2a54127cab0f0eff8254","37":"fadd2586bc21c53a8fd3","38":"d3d9bbd802362df30a4f","39":"271f3a2c23b20122a908","42":"313b1763da69596380a9","43":"a0d2e7a16a0c11d3829e","44":"bf691e1e54162b5506d8","45":"1114be31b54882f2bd76","46":"7389211420939ef5ae7c","47":"c26c0c6ec40497f60687","48":"f4549590d5199e048aff","49":"95b58dcb4e5ee90bd543","50":"0f9eb19eaf7d4b4d469a","51":"bd1a50d1e429828c3e63","52":"0cf49224a3fcf41bf37b","53":"32306e0daf3ff6089430","54":"78bfb68110c7c0c5e5a6","55":"f27412c84fe041cdc8ab","56":"08f1fea6161bcb7ababd","59":"14d0be8936536009d847","60":"62e6a5434ecbb3bc7c6e","61":"fa447fd7b9c4139d6353","62":"9b583338a5a766bea01f","63":"9814a32bd906d64e842e","64":"9ff12d576afa161607d0","65":"2d4da0c98a0ec630733d","66":"e5f017ab9a0e6845876d","67":"0fd46c8ab7321961da2b","68":"f248ea9c881121d0478e","69":"3d008d958a5e07ab510a","70":"96f8f09c45c381907b62","71":"ba0894a7df5ad3a55520","72":"097d3839af54aa801fb4","73":"57c969b8baa8e244bcd3","74":"3a044ef1f90e3050e587","75":"bcfbf321d06c7ccc3381","76":"babf0dbb12f5fe09d80d","77":"9a546bae558504ab255e","78":"4162689875c34deaf31d","79":"fc4f5b8bc3eab03af9ee","80":"8718a64676b1918d6e29","81":"c8b2d620cae1b428a599","82":"6ca5cb8a79d336120080","83":"2330275f01432173b9c4","84":"714287fd7c8130193e93"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.catalog.staging.coursedog.com/6494f09/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
